<template>
  <div class='article-wrapper'>
    <div class="animated fadeIn step-container">
      <div class="row">
      <div class="col-md-8 offset-md-2 alert-container-padding-zero">
        <alertbar/>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 offset-md-2 step-body">

        <h4 class="step-header">
          <div class='title'>{{$t('message.article.title')}}</div>
          <button v-show="!showAddPanel" @click.prevent="enterCreateAritcle"class="add-service btn btn-success">+ {{$t('action_message.add')}}</button>
          <button v-show="showAddPanel" @click.prevent="showAddPanel = !showAddPanel"class="add-service btn btn-info">{{$t('action_message.list')}}</button>
        </h4>

        <div v-if="!showAddPanel" class="article-list-wrapper">
          <bs-input v-model='q' :placeholder="$t('message.article.search_article')"></bs-input>

          <div class='pagination'>
            <div><strong>{{$t('message.pagination.show')}}</strong> {{ paginator.from }} - {{ paginator.to }} <strong>{{$t('message.pagination.from')}}</strong> {{ paginator.total }} <strong>{{$t('message.pagination.rows')}}</strong></div>
            <a class='btn' @click="paginator.prev_page_url && reloadArticle(paginator.prev_page_url)" :class="{ enable: paginator.prev_page_url }">{{$t('message.pagination.prev')}}</a>
            <a class='btn' @click="paginator.next_page_url && reloadArticle(paginator.next_page_url)" :class="{ enable: paginator.next_page_url }">{{$t('message.pagination.next')}}</a>
          </div>

          <div v-if="filtered_articles.length > 0" >
            <transition-group name='list' tag='div'>
              <div class="articles-container" v-for="(a, index) in filtered_articles" :key="a">
                <div class='articles-content'>
										<div class="card">
                      <div class="card-header">
                        <img v-if="a.writer_image" class="writer-image" src='' />
                        <div v-else class="no-writer-image">
                          <i class="fa fa-user-md fa-2x"></i>
                        </div>
                        <div class="writer-name">{{ a.name }}</div>
                        <div class='badge' :class="{'badge-default': a.status === 'unpublished', 'badge-success': a.status === 'published'}" >{{ a.status }}</div>
                        <div class='articles-actions'>
                          <i class="btn btn-sm btn-info fa fa-pencil-square-o" @click.stop="editArticle(a)"></i>
                        </div>
                      </div>
											<div class="card-block">
                        <div v-if="a.featured_image" class='image-wrapper'>
                          <img :src="a.featured_image" class='item-image' alt="Image" />
                        </div>
                        <div class="no-article-image" v-else>
                          <i class="fa fa-file-image-o fa-5x"></i>
                        </div>

                        <h4 class="card-title">{{ a.title }}</h4>
                        <h6 class="card-subtitle mb-2 text-muted">{{ a.created_at }}</h6>
											</div>

										</div>
                </div>
              </div>
            </transition-group>
          </div>
          <h6 class="alert alert-warning" v-else>
            {{$t('message.article.no_article')}}
          </h6>
        </div>

        <div v-show="showAddPanel" class='article-form'>
          <form @submit.prevent>
          <h6>{{$t('message.article.title_article_add')}}</h6>
          <div>
            <bs-input class="remove-padding-bottom" required :label="$t('message.article.name')" v-model="article.title" :placeholder="$t('message.article.name_placeholder')"></bs-input>
            <error-box :message="frmError.title"/>
            <div class="add-padding-bottom" />
          </div>
          <div>
            <ckeditor id="article-content" v-model="article.content" :config="ckeditorConfig"/>
            <error-box :message="frmError.content"/>
          </div>

          <div class="form-divider"></div>

          <div>
            <label>{{$t('message.article.featured_image')}}</label><br/>
            <div class='form-group'>
              <div class='featured-image-group'>
                <i class="fa fa-2x fa-times remove-featured-image" :class="{'remove-featured-image-active': isFeaturedImage}" aria-hidden="true" @click="removeFeatureImage"></i>
                <drop-zone class="featured-image-dropzone" :class="{'featured-image-active': isFeaturedImage}" @fileChange="featuredImageFileChange" :placeholder="featuredImagePlaceholder"></drop-zone>
                <img class="featured-image-preview" ref='featured-image-preview' :src="featured_image_preview" />
              </div>
              <bs-input class='link-image-input' v-model="article.featured_image" :label="$t('message.article.or_use_link')" ></bs-input>
            </div>

            <div class="form-divider"></div>

            <h6>{{$t('message.article.author')}}</h6>
            <div class="written-by-select">
              <div class="form-check form-check-inline">
                <label class="form-check-label">
                  <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" :value="true" v-model="owner_by_doctor"> <i class="fa fa-user-md fa-lg" aria-hidden="true"></i> {{$t('message.article.doctor')}}
                </label>
              </div>
              <div class="form-check form-check-inline">
                <label class="form-check-label">
                  <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" :value="false" v-model="owner_by_doctor"> <i class="fa fa-hospital-o fa-lg" aria-hidden="true"></i> {{$t('message.article.clinic')}}
                </label>
              </div>

              <multiselect id="doctor" 
                    v-if='owner_by_doctor'
                    class="multi-select-form"
                    v-model="selected_doctor" 
                    placeholder="" 
                    :options="doctor_list"
                    :allow-empty="true" 
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label"></multiselect>
            </div>

            <div class="form-divider"></div>

            <div class="status-by-select">
              <label>{{$t('message.article.status')}}</label><br/>
              <div class="form-check form-check-inline">
                <label class="form-check-label">
                  <input class="form-check-input" type="radio" name="status" id="inlineRadio1" value="unpublished" v-model="article.status"> {{$t('message.article.unpublished')}}
                </label>
              </div>
              <div class="form-check form-check-inline">
                <label class="form-check-label">
                  <input class="form-check-input" type="radio" name="status" id="inlineRadio2" value="published" v-model="article.status"> {{$t('message.article.published')}}
                </label>
              </div>
            </div>

            <hr/>

            <div class="row">
              <div class="col-12 form-group">
                <button class="btn btn-lg btn-close" @click.prevent="enterListView">{{$t('action_message.cancel')}}</button>
                <button class="btn btn-add btn-lg btn-success" @click.prevent="addArticle">{{ editMode ? $t('action_message.edit'): $t('action_message.add') }}</button>
                <div v-show='loading' class='btn btn-sm'><sync-loader size='10px'></sync-loader></div>
                <button v-if="editMode" class="btn btn-add btn-lg btn-danger remove-article-action" @click.prevent="removeArticle">{{$t('action_message.remove')}}</button>
              </div>
            </div>

          </div>
          </form>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import Alertbar from '@/components/AlertBar'
import { input as BsInput, datepicker as BsDatepicker } from 'vue-strap'
import VueCoreImageUpload from 'vue-core-image-upload'
import Multiselect from 'vue-multiselect'
import Ckeditor from '@/components/Ckeditor'
import SyncLoader from 'vue-spinner/src/SyncLoader'
import ErrorBox from '@/components/ErrorMessageBox'
import DropZone from '@/components/DropZone'

export default {
  props: {
    id: String
  },
  components: {
    BsInput,
    BsDatepicker,
    VueCoreImageUpload,
    Multiselect,
    Ckeditor,
    SyncLoader,
    Alertbar,
    ErrorBox,
    DropZone
  },
  data () {
    let defaultArticle = {
      title: null,
      content: '',
      status: 'unpublished',
      featured_image: null
    }

    let formCleanError = {
      title: null,
      content: null
    }

    let formDefaultError = {
      title: this.$t('message.article.title_require'),
      content: this.$t('message.article.content_require')
    }

    let featuredPlaceholderImage = '/static/img/default_image.png'

    return {
      loading: false,
      q: '',
      _searchQ: null, // timeout inst
      showAddPanel: false,
      editMode: false,
      articles: [],
      defaultArticle,
      article: Object.assign({}, defaultArticle), // new article
      doctor_list: [{ label: 'doctor1', value: 200 }],
      clinic: {},
      awsConfig: {},
      uploadImageUri: '',
      owner_by_doctor: false,
      alreadyInitCk: false,
      selected_doctor: null,
      paginator: {},
      formDefaultError,
      formCleanError,
      frmError: Object.assign({}, formCleanError),
      ckeditorConfig: {
        toolbar: [
          { name: 'basicstyles', items: ['Bold', 'Italic'] },
          { name: 'paragraph', items: ['BulletedList'] },
          { name: 'styles', items: ['Format'] }
        ]
      },
      featuredImagePlaceholder: `<i class="fa fa-cloud-upload" aria-hidden="true"> ${this.$t('message.article.select_featured_image')}</i>`,
      featured_placeholder_image: featuredPlaceholderImage,
      featured_image_preview: featuredPlaceholderImage
    }
  },
  computed: {
    filtered_articles () {
      return this.articles.sort((a, b) => a.created_at < b.created_at)
    },
    isFeaturedImage () {
      return this.article.featured_image
    }
  },
  watch: {
    q (v, old) {
      let delayTime = 500
      clearTimeout(this._searchQ)
      this._searchQ = setTimeout(() => {
        this.$http.get(this.$APP_CONFIG.api.admin.articles(), { params: {
          search: v,
          clinic_id: this.$guser.user.clinic.id
        }}).then(res => {
          this.articles = res.body.data
          // update paginator
          Object.assign(this.paginator, {
            from: res.body.from,
            to: res.body.to,
            total: res.body.total,
            per_page: res.body.per_page,
            current_page: res.body.per_page,
            next_page_url: res.body.next_page_url,
            prev_page_url: res.body.prev_page_url
          })
        })
      }, delayTime) // delay
    },
    owner_by_doctor (v, old) {
      if (!v) {
        this.article.doctor_id = null
        this.selected_doctor = null
      }
    },
    'article.featured_image' (v, o) {
      this.featured_image_preview = v || this.featured_placeholder_image
    }
  },
  methods: {
    reloadArticle (uri) {
      this.$http.get(uri || this.$APP_CONFIG.api.admin.articles(), { params: {
        clinic_id: this.$route.query.ref_clinic_id
      }}).then(res => {
        this.articles = res.body.data
        Object.assign(this.paginator, {
          from: res.body.from,
          to: res.body.to,
          total: res.body.total,
          per_page: res.body.per_page,
          current_page: res.body.per_page,
          next_page_url: res.body.next_page_url,
          prev_page_url: res.body.prev_page_url
        })
      })
    },
    enterCreateAritcle () {
      this.showAddPanel = true
      this.selected_doctor = null
      this.editMode = false
      this.article = Object.assign({}, this.defaultArticle)
      this.featured_image_preview = this.featured_placeholder_image
      this.clearFormError()
    },
    editArticle (a) {
      this.editMode = true
      this.showAddPanel = true
      this.article = Object.assign({}, a)
      this.featured_image_preview = a.featured_image || this.featured_placeholder_image
      this.clearFormError()
    },
    featuredImageFileChange (file) {
      let imageData = {
        key: `images/${(new Date()).getTime()}-${file.name}`,
        AWSAccessKeyId: this.awsConfig.AWS_ACCESS_KEY,
        acl: 'public-read',
        policy: this.awsConfig.AWS_S3_POLICY.policy,
        signature: this.awsConfig.AWS_S3_POLICY.signature,
        'Content-Type': (file.type !== '' ? file.type : 'application/octet-stream'),
        filename: file.name,
        file: file,
        success_action_status: '201'
      }

      // use FormData object to send form-data in multipart/form-data CONTENT-TYPE
      let data = new FormData()
      for (var field in imageData) {
        data.append(field, imageData[field])
      }

      // upload sent to AWS
      this.$http.post(this.uploadImageUri, data, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
        this.article.featured_image = `https://${this.awsConfig.AWS_CLOUNDFRONT_DOMAIN}/${imageData.key}`
        this.featured_image_preview = this.article.featured_image
      }).catch(reason => {
        // TODO the response will fall to this action ( returned status is 204 )
        this.article.featured_image = `https://${this.awsConfig.AWS_CLOUNDFRONT_DOMAIN}/${imageData.key}`
        this.featured_image_preview = this.article.featured_image
      })
    },
    removeFeatureImage () {
      this.article.featured_image = null
      this.featured_image_preview = this.featured_placeholder_image
    },
    enterListView () {
      this.showAddPanel = false
      this.editMode = false
      this.reloadArticle()
    },
    removeArticle () {
      this.$http.delete(this.$APP_CONFIG.api.admin.articles_id(this.article.id)).then(res => {
        if (res.body) {
          this.enterListView()
          this.article = Object.assign({}, this.defaultArticle)
        }
      })
    },
    addArticle () {
      if (this.editMode) {
        this._updataArticle()
      } else {
        console.log(this.clinic)
        if (this.$guser.isClinic() || this.$guser.isClinicMulti()) {
          this.article.clinic_id = this.clinic.id
        }
        if (this.$guser.isDoctor()) {
          this.article.doctor_id = this.$guser.user.doctor.id
        }
        this.loading = true
        this.clearFormError()
        this.$http.post(this.$APP_CONFIG.api.admin.articles(), this.article).then(res => {
          this.loading = false
          // success
          if (res.body.id) {
            this.enterListView()
            this.$toastr.success(this.$t('message.article.create_success'))
            this.article = Object.assign({}, this.defaultArticle)
          }
        },
        error => {
          this.loading = false
          if (error.body.error) {
            this.showFormFromError(error.body.error)
          }
        })
      }
    },
    _updataArticle () {
      if (this.selected_doctor) this.article.doctor_id = this.selected_doctor.value
      this.loading = true

      this.clearFormError()

      this.$http.put(this.$APP_CONFIG.api.admin.articles_id(this.article.id), this.article).then(res => {
        this.loading = false
        if (res.body.id) {
          this.$toastr.success(this.$t('message.article.update_success'))
          this.article = Object.assign({}, this.defaultArticle)
          this.enterListView()
        }
      },
        error => {
          this.loading = false
          if (error.body.error) {
            this.showFormFromError(error.body.error)
          }
        })
    },
    clearFormError () {
      this.frmError = Object.assign({}, this.formCleanError)
    },
    showFormFromError (error) {
      if (error) {
        this.frmError.title = this.getMessageFromError(error.title)
        this.frmError.content = this.getMessageFromError(error.content)
      }
    },
    getMessageFromError (errorObj) {
      var message = null
      if (errorObj && Array.isArray(errorObj)) {
        message = errorObj.join(' ')
      } else {
        message = errorObj
      }
      return message
    }
  },
  mounted () {
    this.reloadArticle()
    // load doctor list
    if (this.$guser.isClinic() || this.$guser.isClinicMulti()) {
      this.$http.get(this.$APP_CONFIG.api.admin.clinicme(this.$route, this.$guser)).then(res => {
        // TODO use global clinic object
        this.clinic = Object.assign({}, res.body.data)
        console.log(this.clinic)
        if (this.clinic) {
          // fetch doctor list
          this.$http.get(this.$APP_CONFIG.api.admin.doctors_clinic(this.clinic.id)).then(res => {
            this.doctor_list = res.body.data.map(doctor => {
              return {
                value: doctor.id,
                label: (this.$i18n && this.$i18n.locale === 'th') ? doctor.name_th : doctor.name_en
              }
            })

            if (this.article.doctor_id) {
              this.selected_doctor = this.doctor_list.find(d => this.article.doctor_id === d.value)
            }
          })
        }
      })
    }

    // get config
    this.$http.get(this.$APP_CONFIG.api.config()).then(res => {
      this.awsConfig = res.body
      // compose upload uri
      this.uploadImageUri = `https://s3-${this.awsConfig.AWS_S3_REGION}.amazonaws.com/${this.awsConfig.AWS_S3_BUCKET_NAME}/`
    })
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang='scss'>
@import "../../assets/base_container";
@import "../../assets/base_pagination";

.card-img-top {
  width: 100%; 
  height: 200px;
}

.no-article-image {
  background-color: #eee;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  color: #ccc;
}

.card {
  width: 100%;

  .card-header {
    display: flex;
    align-items: center;

    img {
      width: 40px;
      height: 40px;
      border-radius: 20px;
      border: 1px solid #ccc;
    }

    .writer-name {
      flex: 1;
    }

    .article-status {
      font-weight: bold;

      &.published {
        color: green;
      }

      &.unpublished {
        color: grey;
      }

    }

    .articles-actions {
      margin-left: 0.5rem;
    }

    .no-writer-image {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #bbb;
      background-color: #eee;
      width: 40px;
      height: 40px;
      border-radius: 20px;
      border: 1px solid #ccc;
    }
  }

  .card-title {
    margin-top: 0.5rem;
    font-size: 1.25rem;
  }

  .card-subtitle {
    margin-top: -0.75rem;
    font-size: 0.75rem;
  }
}

.list-enter-active, .list-leave-active {
    transition: all 0.3s;
}
.list-enter, .list-leave-to /* .list-leave-active for <2.1.8 */ {
    opacity: 0;
    transform: translateX(10px);
}

.g-core-image-corp-container {
    margin-top: 55px;
}

.image-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.remove-article-action {
  float: right;
}

.link-image-input {
  margin-top: 0.75em;
}

.article-wrapper {
  .step-header {
    display: flex;
    justify-content: center;
    align-items: center;
    .title {
      flex: 1;
    }
  }
}

.featured-image-group {
  position:relative !important;
  overflow:hidden !important;
}

.featured-image-dropzone {
  height: 100% !important;
  width: 100% !important;
  overflow:hidden !important;
  position: absolute !important;
  margin-top: 0px !important;
  margin-left: 0px !important;
  z-index: 1;
}

.featured-image-preview {
    width: 100%;
		height: auto;
		display:block;
		position: relative;
}

.featured-image-active {
  color: transparent !important;
}

.featured-image-active:hover {
  color: #85ace7 !important;
}

.item-image {
  width: 100% !important;
}

.featured-image-group:hover .remove-featured-image-active {
  display: block;
}
.remove-featured-image {
    color: rgba(200, 0, 0, 0.9); 
    position: absolute;
    display: none;
    opacity: 0.8;
    z-index: 101;
    width: 100%;
    text-align: right;
    padding-right: 0.5rem;
    padding-top: 0.3rem;
}

</style>



// WEBPACK FOOTER //
// Article.vue?75fcd13f